<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Fila de processamento</p>
        </div>

        <div class="muven-content">
            <ChannelEntityListSynchronizationCmp
                ref="channelEntityListSynchronizationCmp" 
                @sync-requested-success="syncRequestedSuccessHandler" />

            <Breadcrumb :items="breadcrumbList" class="mb-3" v-if="!loading"/>

            <Loading page v-if="loading" />

            <ResourceNotFound
                v-if="!loading && loadError"
                resource="canal"
                :identifier="$route.params.id"
                list-path="/canais"
                list-label="Voltar para canais"
                :kind="loadErrorKind"
                :error-message="loadErrorMessage"
                @retry="load" />

            <div v-if="!loading && !loadError">
                <div class="mb-3" v-show="!channelStatus.channel.isAllowExportAll()">
                    <div class="muven-tip muven-tip-standalone tip-info mb-0">
                        <fa icon="info" class="tip-icon" />
                        <p>O canal <b>{{channelStatus.channel.name}}</b> não está configurado para enviar o catálogo, portanto apenas as informações de "Pedido", "Preço e estoque" e "Hook" devem ser consideradas.</p>
                    </div>
                </div>

                <div class="mb-3">
                    <button class="btn btn-outline-secondary"
                        :disabled="syncingInfo"
                        @click="openModalChannelEntityListSync(channel)">
                        Forçar sincronização
                    </button>

                    <button class="btn btn-outline-secondary ml-3"
                        :disabled="retrievingChannelsStatusSynchronization"
                        @click="getChannelsStatusSynchronization()">
                        Atualizar status da fila

                        <Loading v-show="retrievingChannelsStatusSynchronization" />
                    </button>
                </div>

                <div class="table-responsive">
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Entidade</th>
                                <th>Status</th>
                                <th class="text-right">Dados a serem processados</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-show="channelStatus.channel.isAllowExportAll() || channelStatus.channel.isAllowExportInsertProductAndUpdateStockAndPrice() || channelStatus.channel.isAllowExportInsertProductAndUpdateStock()">
                                <td>Produto</td>
                                <td>
                                    <span v-if="channelStatus.product === 0">
                                        <span class="muven-td-icon">
                                            <fa icon="check-circle"
                                                    class="text-success" />
                                        </span>

                                        <span>Informações atualizadas</span>
                                    </span>

                                    <span v-if="channelStatus.product > 0">
                                        <span class="muven-td-icon">
                                            <fa icon="hourglass-half" 
                                                class="text-muted" />
                                        </span>

                                        <span>Em andamento</span>
                                    </span>
                                </td>
                                <td class="text-right">{{channelStatus.product}}</td>
                            </tr>
                            <tr v-show="channelStatus.channel.isAllowExportAll()">
                                <td>Imagem</td>
                                <td>
                                    <span v-if="channelStatus.product_image === 0">
                                        <span class="muven-td-icon">
                                            <fa icon="check-circle"
                                                    class="text-success" />
                                        </span>

                                        <span>Informações atualizadas</span>
                                    </span>

                                    <span v-if="channelStatus.product_image > 0">
                                        <span class="muven-td-icon">
                                            <fa icon="hourglass-half" 
                                                class="text-muted" />
                                        </span>

                                        <span>Em andamento</span>
                                    </span>
                                </td>
                                <td class="text-right">{{channelStatus.product_image}}</td>
                            </tr>
                            <tr>
                                <td>Preço e estoque</td>
                                <td>
                                    <span v-if="channelStatus.product_store === 0">
                                        <span class="muven-td-icon">
                                            <fa icon="check-circle"
                                                    class="text-success" />
                                        </span>

                                        <span>Informações atualizadas</span>
                                    </span>

                                    <span v-if="channelStatus.product_store > 0">
                                        <span class="muven-td-icon">
                                            <fa icon="hourglass-half" 
                                                class="text-muted" />
                                        </span>

                                        <span>Em andamento</span>
                                    </span>
                                </td>
                                <td class="text-right">{{channelStatus.product_store}}</td>
                            </tr>
                            <tr v-show="channelStatus.channel.isAllowExportAll()">
                                <td>Categoria</td>
                                <td>
                                    <span v-if="channelStatus.category === 0">
                                        <span class="muven-td-icon">
                                            <fa icon="check-circle"
                                                    class="text-success" />
                                        </span>

                                        <span>Informações atualizadas</span>
                                    </span>

                                    <span v-if="channelStatus.category > 0">
                                        <span class="muven-td-icon">
                                            <fa icon="hourglass-half" 
                                                class="text-muted" />
                                        </span>

                                        <span>Em andamento</span>
                                    </span>
                                </td>
                                <td class="text-right">{{channelStatus.category}}</td>
                            </tr>
                            <tr v-show="channelStatus.channel.isAllowExportAll()">
                                <td>Marca</td>
                                <td>
                                    <span v-if="channelStatus.brand === 0">
                                        <span class="muven-td-icon">
                                            <fa icon="check-circle"
                                                    class="text-success" />
                                        </span>

                                        <span>Informações atualizadas</span>
                                    </span>

                                    <span v-if="channelStatus.brand > 0">
                                        <span class="muven-td-icon">
                                            <fa icon="hourglass-half" 
                                                class="text-muted" />
                                        </span>

                                        <span>Em andamento</span>
                                    </span>
                                </td>
                                <td class="text-right">{{channelStatus.brand}}</td>
                            </tr>
                            <tr>
                                <td>Pedido</td>
                                <td>
                                    <span v-if="channelStatus.order === 0">
                                        <span class="muven-td-icon">
                                            <fa icon="check-circle"
                                                    class="text-success" />
                                        </span>

                                        <span>Informações atualizadas</span>
                                    </span>

                                    <span v-if="channelStatus.order > 0">
                                        <span class="muven-td-icon">
                                            <fa icon="hourglass-half" 
                                                class="text-muted" />
                                        </span>

                                        <span>Em andamento</span>
                                    </span>
                                </td>
                                <td class="text-right">{{channelStatus.order}}</td>
                            </tr>
                            <tr>
                                <td>Hook</td>
                                <td>
                                    <span v-if="channelStatus.hook_event === 0">
                                        <span class="muven-td-icon">
                                            <fa icon="check-circle"
                                                    class="text-success" />
                                        </span>

                                        <span>Informações atualizadas</span>
                                    </span>

                                    <span v-if="channelStatus.hook_event > 0">
                                        <span class="muven-td-icon">
                                            <fa icon="hourglass-half" 
                                                class="text-muted" />
                                        </span>

                                        <span>Em andamento</span>
                                    </span>
                                </td>
                                <td class="text-right">{{channelStatus.hook_event}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ChannelStatusSynchronizationModel } from '../../monitoring/models/ChannelStatusSynchronizationModel'
import serviceStatusInformationService from '../../monitoring/services/ServiceStatusInformationService'
import subscriberService from '../../subscriber/services/SubscriberService'
import { ChannelModel } from '../models/ChannelModel'
import ChannelService from '../services/ChannelService'
import ChannelEntityListSynchronizationCmp from '../components/ChannelEntityListSynchronizationCmp.vue'
import ResourceLoadError from '../../utils/mixins/ResourceLoadError'
import { getChannelNotFoundBreadcrumb } from '../utils/ChannelNotFoundBreadcrumb'

export default {
    name: 'ChannelStatusSynchronizationListView',
    components: {
        ChannelEntityListSynchronizationCmp,
    },
    data() {
        return {
            loading: true,
            syncingInfo: false,
            retrievingChannelsStatusSynchronization: false,
            channel: new ChannelModel(),
            channelStatus: new ChannelStatusSynchronizationModel(),
            breadcrumbList: [],
        }
    },
    mixins: [
        ResourceLoadError,
    ],
    mounted() {
        this.load()
    },
    methods: {
        async load() {
            this.loading = true
            this.loadError = null

            try {
                [this.channel, this.channelStatus] = await Promise.all([
                    ChannelService.getChannelById(this.$route.params.id),
                    serviceStatusInformationService.getChannelStatusSynchronizationByChannelId(this.$route.params.id),
                ])

                this.channelStatus.setChannel(this.channel)

                this.breadcrumbList = [
                    {
                        id: 0,
                        description: 'Canais',
                        path: '/canais'
                    },
                    {
                        id: 1,
                        description: `Configurações ${this.channel.name}`,
                        channel: this.channel,
                        path: `/canais/${this.channel.id}/configuracoes`,
                    },
                    {
                        id: 2,
                        description: `Fila de processamento em ${this.channel.name}`,
                        path: '',
                    },
                ];
            } catch(err) {
                this.loadError = err
                this.breadcrumbList = getChannelNotFoundBreadcrumb(this.$route.params.id)
            }

            this.loading = false
        },
        async openModalChannelEntityListSync(channel) {
            this.$refs.channelEntityListSynchronizationCmp.show(channel);
        },
        async syncRequestedSuccessHandler() {
            await this.getChannelsStatusSynchronization()
        },
        async getChannelsStatusSynchronization() {
            this.retrievingChannelsStatusSynchronization = true

            try {
                // allowExport não é retornado corretamente pelo serviço, então eu salvo o estado original
                // para o devolver ao final da requisição
                const originalChannelStatus = this.channelStatus;
                this.channelStatus = await serviceStatusInformationService.getChannelStatusSynchronizationByChannelId(this.$route.params.id);
                this.channelStatus.channel.allowExport = originalChannelStatus.channel.allowExport;

                this.$floatingAlert.success({
                    message: 'Informações da fila de processamento atualizadas com sucesso.',  
                    timeVisible: 10000,
                })
            } catch (err) {
                this.$floatingAlert.error({
                    title: 'Oops!',
                    message: e.message || 'Houve um problema no momento de obter os status dos canais. Tente novamente mais tarde',
                })
            }

            this.retrievingChannelsStatusSynchronization = false
        },
    }
}
</script>
